// extracted by mini-css-extract-plugin
export default {"-large":"Bmt33Lx7qGoel0S1IDO7","signupLink":"Q6H3tMDYx2igMKR58Q5X","backHeadingContainer":"_w4TbhktLf0cNYSMd0Bp","iconContainer":"U0SK9UgGoZX0aI1Faeu3"};